import React from 'react';
import type { User, Language } from '../types';
import { getTranslation } from '../utils/translations';

interface ImpersonationBannerProps {
    viewUser: User;
    language: Language;
    onExitImpersonation: () => void;
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({
    viewUser,
    language,
    onExitImpersonation,
}) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);
    const displayName = viewUser.nickname
        || `${viewUser.firstName || ''} ${viewUser.lastName || ''}`.trim()
        || viewUser.email;

    return (
        <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-3 text-xs font-bold z-40 shrink-0">
            <span className="truncate">
                {t('impersonatingBanner').replace('{name}', displayName)}
            </span>
            <button
                type="button"
                onClick={onExitImpersonation}
                className="shrink-0 px-3 py-1.5 rounded-lg bg-amber-950 text-amber-50 hover:bg-amber-900 transition-colors uppercase tracking-wide text-[10px]"
            >
                {t('exitImpersonation')}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
